import { Box, LinearProgress, Stack, styled, Typography } from '@mui/material';
import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface ProfileCompletionBannerProps {
    percentage: number;
    tip: string | null;
}

function ProfileCompletionBanner({ percentage, tip }: ProfileCompletionBannerProps) {
    const { t } = useTranslation('profile');

    return (
        <BannerContainer>
            <Stack direction="row"
                spacing={ 1.5 }
                alignItems="flex-start">
                <Stack spacing={ 0.5 }
                    flex={ 1 }>
                    <Title variant="subtitle1">
                        <Trans t={ t }
                            i18nKey="completion.title"
                            values={{ percentage }}
                            components={{ bold: <b /> }}
                        />
                    </Title>
                    { tip && (
                        <Subtitle variant="body2">
                            { tip }
                        </Subtitle>
                    ) }
                </Stack>
            </Stack>
            <LinearProgress
                variant="determinate"
                value={ percentage }
                color="success"

                sx={{
                    borderRadius: 1
                }}
            />
        </BannerContainer>
    );
}

export default memo(ProfileCompletionBanner);

const BannerContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2)
}));

const Title = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    '& b': {
        fontWeight: theme.typography.fontWeightMedium
    }
}));

const Subtitle = styled(Typography)({
    opacity: 0.85
});
